function InksoftMascot() {

}

InksoftMascot.activeMascots = [];
InksoftMascot.events = {
    isInit: true,
    designIdeasCategories: [],

    init: function() {
        var that = this;

        if (that.isInit) {
            $("#select-mascot-inksoft-modal").on("click", ".existing-mascot-category a.mascot-type", that.onSelectMascotCategory);
            $("#select-mascot-inksoft-modal").on("click", ".mascot-categories a.category-item", that.onClickCategoryItem);
            $("#select-mascot-inksoft-modal").on("click", ".stock-mascot-container a.mascot-btn", that.onClickMascotItem);
            $("#select-mascot-inksoft-modal").on("click", ".edit-current-mascot", that.onEditMascot);
            $("#select-mascot-inksoft-modal").on("click", ".apply-mascot", that.onApplyMascot);
            $("#select-mascot-inksoft-modal, #inksoft-design-editor-modal, #inksoft-design-editor-modal-with-conflict").on("click", ".cancel-mascot", that.onCancelCustomMascot);

            $("#select-mascot-inksoft-modal").on("click", ".inksoft-menu .inksoft-menu-item", that.onChangeMenu);
            that.isInit = false;
        }
    },

    onSelectMascotCategory: function() {
        var type = $(this).data("type");

        if (type === "inksoft") {
            InksoftMascot.uiHandler.showLoader();
            InksoftMascot.funcs.loadDesignIdeaCategories();
        } else {
            var userDesignType = $("#select-mascot-inksoft-modal .my-design-category li.uk-active a").data("type");
            if (userDesignType === "archive") {
                UserStockMascot.funcs.loadMyStockMascotArchive();
            } else {
                UserStockMascot.funcs.loadMyStockMascotActive();
            }
        }

        $("input[name='search-mascot']").val('');
    },

    onShowStockMascot: function() {
        UserStockMascot.events.init();
        InksoftMascot.events.init();

        if (ub.user) {
            $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").first().parent().removeClass("uk-hidden");
            UIkit.switcher(".existing-mascot-category").show(0);
            $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").first().trigger("click");
        } else {
            $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").first().parent().addClass("uk-hidden");
            UIkit.switcher(".existing-mascot-category").show(1);
            $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").last().trigger("click");
        }

        $("input[name='search-mascot']").val('');
        UIkit.switcher(".inksoft-menu").show(0);
        UIkit.modal("#select-mascot-inksoft-modal").show();
    },

    onClickCategoryItem: function() {
        var category_id = $(this).data("category-id");
        
        InksoftMascot.uiHandler.showLoader();
        InksoftMascot.funcs.loadDesignIdeasPerCategories(category_id, function(data) {
            InksoftMascot.activeMascots = data;
            InksoftMascot.uiHandler.renderMascots(data);
            InksoftMascot.uiHandler.hideLoader();
        });

        $(".mascot-categories").find("li.uk-active").removeClass("uk-active");
        $(this).parent().addClass("uk-active");
    },

    onClickMascotItem: function() {
        ub.data.currentStockMascotID = $(this).data('stock-mascot-id');
        var data = {
            id: ub.data.currentStockMascotID,
            image: $(this).data('image'),
            name: $(this).data("name"),
        }

        $("#select-mascot-inksoft-modal .stock-mascot-container .mascot-item").find(".activation-container").addClass("uk-hidden");
        $(this).find("div.activation-container").removeClass("uk-hidden");

        InksoftMascot.uiHandler.renderMascotPreivew(data);
    },

    onEditMascot: function() {
        var design_id = $(this).data("stock-mascot-id");
        var application = ub.data.newApplication;
        var application_code = typeof application !== "undefined" ? application.code : undefined;
        InksoftMascot.funcs.onShowEditDesignModal(design_id, application_code, function() {
            UIkit.modal("#select-mascot-inksoft-modal").hide();
            UIkit.modal("#inksoft-design-editor-modal").show();
        });
    },

    onApplyMascot: function() {
        var that = this;
        var tab = $(".mascot-type[data-type='inksoft']");

        if (tab.parent().hasClass("uk-active")) {
            var stockID = ub.data.currentStockMascotID;
            var application = ub.data.newApplication;

            if (typeof stockID !== "undefined") {
                if (ub.applicationMascotAsPattern || ub.partMascotAsPattern) {
                    ApplicationCore.funcs.applyMascotAsPatternInApplication(stockID, application);
                } else {
                    ApplicationCore.funcs.applyMascotOnUniform(stockID, application);
                }
            } else {
                ub.utilities.warn("Missing design id")
            }

            UIkit.modal("#select-mascot-inksoft-modal").hide();
        }

        if (ub.config.blockPattern === 'Stock Sideline Quarter Zip') {

            $('.color_panel_container').hide()

        }
    },

    onCancelCustomMascot: function() {
        var application = ub.data.newApplication;
        if (!ub.data.isEditing) {
            if (typeof application !== "undefined") {
                ub.funcs.deleteLocation(application.code);
                ub.data.newApplication = undefined;
            }
        }

        ub.data.isEditing = false;

        if (typeof ub.data.newApplication !== "undefined") {
            if (ub.applicationMascotAsPattern) {
                ub.funcs.activateApplications(application.code);
            } else if (ub.partMascotAsPattern) {
                ub.funcs.activatePatterns();
            } else {
                if (ub.data.newApplication.application_type === "mascot") {
                    ub.funcs.activateMascots(application.code);
                } else {
                    ub.funcs.activateEmbellishments(application.code);
                }
            }
        }

        ub.applicationMascotAsPattern = false;
        ub.partMascotAsPattern = false;
        Inksoft.funcs.closeInksoftModal();
    },

    onChangeMenu: function() {
        var type = $(this).data("type");
        var application = ub.data.newApplication;

        switch (type) {
            case "exiting":
                if (ub.user) {
                    $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").first().parent().removeClass("uk-hidden");
                    UIkit.switcher(".existing-mascot-category").show(0);
                    $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").first().trigger("click");
                } else {
                    $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").first().parent().addClass("uk-hidden");
                    UIkit.switcher(".existing-mascot-category").show(1);
                    $("#select-mascot-inksoft-modal .existing-mascot-category a.mascot-type").last().trigger("click");
                }

                break;

            case "create":
                $("#select-mascot-inksoft-modal .create-mascot").html("");
                var element = document.querySelector("#select-mascot-inksoft-modal .create-mascot");
                var application_code = typeof application !== "undefined" ? application.code : undefined;
                Inksoft.funcs.loadInksoftDesigner(element, application_code);
                break;

            case "upload":
                $("#select-mascot-inksoft-modal .upload-mascot").html("");
                var element = document.querySelector("#select-mascot-inksoft-modal .upload-mascot");
                var application_code = typeof application !== "undefined" ? application.code : undefined;
                Inksoft.funcs.loadInksoftUploader(element, application_code);
                break;
            default:
                // statements_def
                break;
        }
    }
}

InksoftMascot.funcs = {
    loadDesignIdeaCategories: function() {
        if (typeof InksoftMascot.events.designIdeasCategories !== "undefined" && _.size(InksoftMascot.events.designIdeasCategories) > 0) {
            InksoftMascot.uiHandler.renderCategoryies(_.sortBy(InksoftMascot.events.designIdeasCategories, "order"));
        } else {
            Inksoft.funcs.getDesignIdeaCategories(function(response) {
                if (response.OK) {
                    _.map(response.Data, function(category) {
                        var category = {
                            ID: category.ID,
                            Name: category.Name,
                            isParent: _.size(category.Children) > 0,
                            Children: category.Children
                        }

                        if (category.Name.toLowerCase().includes("tailsweeps")) {
                            category.order = 1
                        } else if (category.Name.toLowerCase().includes("mascots")) {
                            category.order = 2
                        } else if (category.Name.includes("Sports & Athletics")) {
                            category.order = 3
                        }

                        InksoftMascot.events.designIdeasCategories.push(category);
                    })

                    InksoftMascot.uiHandler.renderCategoryies(_.sortBy(InksoftMascot.events.designIdeasCategories, "order"));
                } else {
                    UIkit.modal("#select-mascot-inksoft-modal").hide();
                    console.log("Failed to fetch design ideas categories");
                }
            }, function(error) {
                UIkit.modal("#select-mascot-inksoft-modal").hide();
                console.log(error)
            });
        }
    },

    loadDesignIdeasPerCategories: function(category_id, callback) {
        Inksoft.funcs.getDesignIdeasByCategory(category_id, function(response) {
            if (response.OK) {
                var data = [];

                _.map(response.Data, function(mascot) {
                    data.push({
                        ImageUrl: 'https://images.inksoft.com' + mascot.Canvases[0].PngRelativeUrl,
                        Name: mascot.Name,
                        ID: mascot.DesignID
                    });
                })

                callback(data);
            } else {
                console.log("Empty")
            }
        }, function(error) {
            UIkit.modal("#select-mascot-inksoft-modal").hide();
            console.log("Failed to fetch design ideas categories");
        });
    },

    onShowEditDesignModal: function(design_id, application_id, callback) {
        $("#inksoft-design-editor-modal #InksoftDesignEditor").html("");
        var element = document.getElementById("InksoftDesignEditor");
        Inksoft.funcs.loadInksoftDesigner(element, application_id, design_id, callback);
    },

    onShowEditDesignConflict: function(design_id, application_id, callback) {
        $("#inksoft-design-editor-modal-with-conflict #InksoftDesignEditorConflict").html("");
        var element = document.getElementById("InksoftDesignEditorConflict");
        Inksoft.funcs.loadInksoftDesigner(element, application_id, design_id, callback);
    }
}

InksoftMascot.uiHandler = {
    renderCategoryies: function(data) {
        var template = document.getElementById("inksoft-design-categories").innerHTML;
        var markup = Mustache.render(template, {
            categories: data
        });

        $("#select-mascot-inksoft-modal .mascot-categories").html("");
        $("#select-mascot-inksoft-modal .mascot-categories").html(markup);

        $(".mascot-categories li").first().find("a").trigger("click");
    },

    renderMascots: function(data) {
        var template = document.getElementById("inksoft-stock-mascot-items").innerHTML;
        var markup = Mustache.render(template, {
            mascots: data
        });

        $("#select-mascot-inksoft-modal div.stock-mascot-container").html("");
        $("#select-mascot-inksoft-modal div.stock-mascot-container").html(markup);

        // Select First Item
        $("#select-mascot-inksoft-modal .stock-mascot-container .mascot-item").first().find("a.mascot-btn").trigger("click");
    },

    renderMascotPreivew: function(data) {
        var template = document.getElementById("inksoft-stock-mascot-preview").innerHTML;
        var markup = Mustache.render(template, {
            id: data.id,
            name: data.name,
            image: data.image,
            type: "design-idea"
        });

        $("#select-mascot-inksoft-modal div.stock-mascot-preview").html("");
        $("#select-mascot-inksoft-modal div.stock-mascot-preview").html(markup);
    },

    renderConflictColors: function(data) {
        var template = document.getElementById("m-conflicting-colors-uikit").innerHTML;
        var markup = Mustache.render(template, data);

        $("#inksoft-design-editor-modal-with-conflict .conflictingColors").html("");
        $("#inksoft-design-editor-modal-with-conflict .conflictingColors").html(markup);
    },

    showLoader: function() {
        $("#select-mascot-inksoft-modal div.stock-mascot-container").addClass("uk-hidden");
        $("#select-mascot-inksoft-modal div.stock-mascot-loading-screen-content").removeClass("uk-hidden");
    },

    hideLoader: function() {
        $("#select-mascot-inksoft-modal div.stock-mascot-loading-screen-content").addClass("uk-hidden");
        $("#select-mascot-inksoft-modal div.stock-mascot-container").removeClass("uk-hidden");
    }
}